import { lazy } from 'react';

const LFPRoutes = [
    {
        path: '/new_lfp_referrals',
        component: lazy(() => import('../../pages/LFP/NewReferrals')),
        meta: {
            action: 'read',
            resource: 'lfp_lawyer_referrals',
        },
    },
    {
        path: '/lfp_lawyer_leads',
        component: lazy(() => import('../../pages/LFP/Leads')),
        meta: {
            action: 'read',
            resource: 'lfp_lawyer_referrals',
        },
    },
    {
        path: '/lfp_lawyer_matters',
        component: lazy(() => import('../../pages/LFP/Matters')),
        meta: {
            action: 'read',
            resource: 'lfp_lawyer_referrals',
        },
    },
    {
        path: '/lfp_contacts',
        component: lazy(() => import('../../pages/LFP/Contacts')),
        meta: {
            action: 'read',
            resource: 'lfp_contacts',
        },
    },
    {
        path: '/lfp_contact/:contactId',
        component: lazy(() => import('../../pages/LFP/ContactDetail')),
        meta: {
            action: 'read',
            resource: 'lfp_contacts',
        },
    },
    {
        path: '/schedule_lfp_appointment',
        layout: 'auto',
        showNavbar: true,
        showMenus: false,
        showLogin: false,
        navbarTitle: 'Powered by',
        containerType: 'fluid',
        component: lazy(() => import('../../pages/LFP/ScheduleAppointment')),
        meta: {
            publicRoute: true,
            // action: 'read',
            // resource: 'lfp_contacts',
        },
    },
    {
        path: '/reschedule_lfp_appointment',
        layout: 'auto',
        showNavbar: true,
        showMenus: false,
        showLogin: false,
        navbarTitle: 'Powered by',
        containerType: 'fluid',
        component: lazy(() => import('../../pages/LFP/RescheduleAppointment')),
        meta: {
            publicRoute: true,
            // action: 'read',
            // resource: 'lfp_contacts',
        },
    },
    {
        path: '/lfp_appointments',
        exact: true,
        component: lazy(() => import('../../pages/Matters/Appointments')),
        meta: {
            action: 'read',
            resource: 'lfp_appointments',
            //menuCollapsed: true,
        },
    },
];

export default LFPRoutes;
